<script>
import AppDisplay from '@/components/AppDisplay.vue'
import Bioinsumos from '../components/Bioinsumos.vue'
import Irrigacao from '../components/Irrigacao.vue'
import Financiamento from '../components/Financiamento.vue'
import Descricao from '../components/Descricao.vue'
import { formataStringYearMonthToBr } from '@/utils/utils'
import { opcoesFinalidadeFloresta, opcoesEspeciesFlorestais } from '@/libs/constants/praticas/opcoesSelects'

export default {
  components: {
    AppDisplay,
    Bioinsumos,
    Irrigacao,
    Financiamento,
    Descricao
  },
  props: {
    pratica: {
      type: Object
    }
  },
  methods: {
    formataDataInicio (value) {
      if (!value) return ''
      return formataStringYearMonthToBr(value)
    },
    formataFinalidadeFloreta (values) {
      if (!values || !values.length) return ''
      const opcoesFormatadas = values.filter(v => v !== 'OUTROS').map(value => opcoesFinalidadeFloresta.find(opcao => opcao.id === value)?.nome)
      return opcoesFormatadas.join(', ')
    },
    formataEspeciesFlorestais (values) {
      if (!values || !values.length) return ''
      const opcoesFormatadas = values.map(value => {
        if (value.especie === 'OUTROS') {
          return `• Espécie: ${value.especificacao} / Espaçamento: ${value.espacamento}`
        }
        return `• Espécie: ${opcoesEspeciesFlorestais.find(especie => especie.id === value.especie).nome} / Espaçamento: ${value.espacamento}`
      })
      return opcoesFormatadas.join('<br /> ')
    }
  }
}
</script>

<template>
  <div>
    <div>
      <span class="title-praticas">Dados da prática</span>
      <hr />
    </div>
    <el-row>
      <el-col :span="12">
        <app-display label="Área (ha):" :content="pratica.area" />
        <app-display label="Finalidade da floresta:" :content="formataFinalidadeFloreta(pratica.finalidades)" />
        <app-display label="Espécies florestais utilizadas:" :content="formataEspeciesFlorestais(pratica.especiesFlorestais)" :isContentInNextLine="true" />
      </el-col>
      <el-col :span="12">
        <app-display label="Data de início da implementação (mês e ano):" :content="formataDataInicio(pratica.dataInicio)" />
        <app-display v-if="pratica.finalidades.length && pratica.finalidades.includes('OUTROS')" label="Outras finalidade da floresta:" :content="pratica.outrasFinalidades" />
      </el-col>
    </el-row>
    <Bioinsumos :bioinsumo="{utilizaBioinsumos: pratica.utilizaBioinsumos, bioinsumos: pratica.bioinsumos}" />
    <Irrigacao :irrigacao="{possuiIrrigacao: pratica.possuiIrrigacao, ...pratica.irrigacao}" />
    <Financiamento :financiamento="{financiamentos: pratica.financiamentos, outroFinanciamento: pratica.outroFinanciamento}" />
    <Descricao :descricao="pratica.descricao" />
  </div>
</template>

<style lang="scss" scoped>
  @import '../style.scss'
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/FP/FP.vue